var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.625 21V6.125C2.625 5.64175 3.01675 5.25 3.5 5.25H24.5C24.9832 5.25 25.375 5.64175 25.375 6.125V21C25.375 21 25.375 21.7249 24.8624 22.2374C24.8624 22.2374 24.3499 22.75 23.625 22.75H4.375C4.375 22.75 3.65013 22.75 3.13756 22.2374C3.13756 22.2374 2.625 21.7249 2.625 21ZM4.375 21H23.625V7H4.375V21Z",
    fill: "#5932ea"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09126 5.47999C3.92988 5.33206 3.71892 5.25 3.5 5.25C3.48733 5.25 3.47465 5.25028 3.46199 5.25083C3.23015 5.26091 3.0118 5.36267 2.85499 5.53374C2.70706 5.69512 2.625 5.90608 2.625 6.125C2.625 6.13767 2.62528 6.15035 2.62583 6.16301C2.63591 6.39485 2.73767 6.6132 2.90874 6.77001L13.4087 16.395C13.7433 16.7017 14.2567 16.7017 14.5913 16.395L25.0907 6.77055C25.2715 6.60481 25.375 6.37027 25.375 6.125L25.375 6.11773C25.3732 5.90132 25.2912 5.69327 25.145 5.53374C24.9882 5.36267 24.7699 5.26091 24.538 5.25083C24.5253 5.25028 24.5127 5.25 24.5 5.25L24.496 5.25001C24.2784 5.25101 24.0691 5.333 23.9087 5.47999L14 14.563L4.09126 5.47999Z",
    fill: "#5932ea"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.eb215865dd1e7681c949e54b73882805.svg";
export { ForwardRef as ReactComponent };